import React, { useState, useEffect } from 'react';
import { API_BASE } from '../../config';
import { useDomainValidation } from '../../hooks/useDomainValidation';
import DomainValidationModal from '../DomainValidationRetryModal';

import { useEscapeToClose } from '../../hooks/useEscapeToClose';
function PreferenceForm({ onClose, onSave, fetchWithAuth, editingPreference }) {
  useEscapeToClose(onClose);   // Escape dismisses this modal
  const { domainValidation, handleValidationResponse, clearValidation } = useDomainValidation();
  const [formData, setFormData] = useState({
    preference_type: 'dietary_restriction',
    name: '',
    preference_ranking: 3,
    notes: ''
  });

  // Populate form with editing data
  useEffect(() => {
    if (editingPreference) {
      setFormData({
        preference_type: editingPreference.preference_type || 'dietary_restriction',
        name: editingPreference.name || '',
        preference_ranking: editingPreference.preference_ranking || 3,
        notes: editingPreference.notes || ''
      });
    }
  }, [editingPreference]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert preference_ranking to integer
    const submitData = {
      ...formData,
      preference_ranking: parseInt(formData.preference_ranking)
    };

    try {
      const url = editingPreference
        ? `${API_BASE}/api/health/preferences/${editingPreference.id}`
        : `${API_BASE}/api/health/preferences`;

      const method = editingPreference ? 'PUT' : 'POST';

      const response = await fetchWithAuth(url, {
        method: method,
        body: JSON.stringify(submitData)
      });

      const validationResult = await handleValidationResponse(response, 'food preference');
      if (validationResult === true) {
        onSave();
        onClose();
      }
    } catch (error) {
      console.error('Failed to save preference:', error);
    }
  };

  return (
    <>{domainValidation && (
      <DomainValidationModal
        isOpen={true}
        mode={domainValidation.mode}
        rejectionMessage={domainValidation.message}
        entityType={domainValidation.entityType}
        onClose={clearValidation}
      />
    )}<div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{editingPreference ? 'Edit Food Preference' : 'Add Food Preference'}</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Type</label>
            <select
              className="form-select"
              value={formData.preference_type}
              onChange={(e) => setFormData(prev => ({...prev, preference_type: e.target.value}))}
            >
              <option value="dietary_restriction">Dietary Restriction</option>
              <option value="allergy">Allergy</option>
              <option value="like">Like</option>
              <option value="dislike">Dislike</option>
              <option value="cuisine">Cuisine Preference</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-input"
              value={formData.name}
              onChange={(e) => setFormData(prev => ({...prev, name: e.target.value}))}
              placeholder="e.g. Gluten, Dairy, Italian Food"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Preference Type Ranking</label>
            <select
              className="form-select"
              value={formData.preference_ranking}
              onChange={(e) => setFormData(prev => ({...prev, preference_ranking: e.target.value}))}
            >
              <option value={1}>1 - Low / Dislike / Mild</option>
              <option value={2}>2 - Between 1 and 3</option>
              <option value={3}>3 - Medium / Acceptable / Moderate</option>
              <option value={4}>4 - Between 3 and 5</option>
              <option value={5}>5 - High / Like / Severe</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Notes</label>
            <textarea
              className="form-textarea"
              value={formData.notes}
              onChange={(e) => setFormData(prev => ({...prev, notes: e.target.value}))}
              placeholder="Additional details or context"
            />
          </div>

          <div className="flex gap-2">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {editingPreference ? 'Update Preference' : 'Save Preference'}
            </button>
          </div>
        </form>
      </div>
    </div></>
  );
}

export default PreferenceForm;
